import React from "react";
import { Provider, Text, ThemeInput } from "@fluentui/react-northstar";
import { Chart, EChartTypes } from "../../../../shared/components/msTeamsUiCharts";
import { chartThemes } from "msTeamsUI/chartThemes/chartThemes";
import { V360ReportData } from "view360Card/models";
import { ReportBox } from "../reportBox/ReportBox";
import orderBy from "lodash/orderBy";
import { constants } from "shared/constants";

export interface MonthlyProps {
    report: V360ReportData;
    theme: ThemeInput;
}

export const Monthly: React.FC<MonthlyProps> = (props) => {
    const barData = {
        labels: props.report.labels,
        datasets: orderBy(
            props.report.seriesList.filter((s) => s.unitType === constants.unitTypes.numeric),
            [(s) => s.code === "CURRENT"],
            ["asc"]
        ).map((s) => {
            return {
                label: s.name,
                barPercentage: 0.4,
                data: s.dataset,
            };
        }),
    };

    const getMonthlyChart = () => {
        return (
            <Provider theme={props.theme} styles={{ height: "100%" }}>
                <Chart
                    title={props.report.name}
                    type={EChartTypes.Bar}
                    data={barData}
                    presentsMoney
                    tooltipHideFooter
                />
            </Provider>
        );
    };

    return <ReportBox title={props.report.name || ""} content={getMonthlyChart()} />;
};
